import { defineStore, storeToRefs } from 'pinia';
import { shallowRef, type Ref } from 'vue';
import { type ActiveLottery, getActiveLottery } from '@/shared/api/getActiveLottery';
import { useTravelataPinia } from '@/shared/composables';

export const DREAM_TOUR_STORE_ID = 'travelata/serpBanners/dreamTour';

const defineDreamTourStore = defineStore(DREAM_TOUR_STORE_ID, () => {
  const lottery = shallowRef<ActiveLottery | null>(null);
  let request: Promise<void> | null = null;

  async function fetchLottery(): Promise<void> {
    const result = await getActiveLottery();
    lottery.value = result?.bannerActive ? result : null;
  }

  function load(): Promise<void> {
    request ??= fetchLottery();

    return request;
  }

  return { lottery, load };
});

export interface UseDreamTourLottery {
  lottery: Readonly<Ref<ActiveLottery | null>>;
  load: () => Promise<void>;
}

export function useDreamTourLottery(): UseDreamTourLottery {
  const store = defineDreamTourStore(useTravelataPinia());
  const { lottery } = storeToRefs(store);

  return { lottery, load: store.load };
}
